import React, { useState, useMemo } from 'react';
import { Download } from 'lucide-react';
import Button from '../design-system/Button';

/**
 * APEX v8.6 — ExportTab
 * Export recap + backup JSON. Extrait de App.jsx v8.6.
 */

function formatRecap(games, label) {
  if (!games || games.length === 0) return '';
  const header = `=== ${label} — ${new Date().toLocaleDateString('fr-FR')} ===\n`;
  const lines = games.map(g =>
    `[${g.result}] ${g.champion} vs ${g.enemyAdc} (+${g.support}) — ${g.kills}/${g.deaths}/${g.assists} — ${g.csPerMin}cs — ${g.duration}min`
  );
  return header + lines.join('\n');
}

export default function ExportTab({ games }) {
  const [exportType, setExportType] = useState('session');
  const [copied, setCopied] = useState(false);

  const exportContent = useMemo(() => {
    if (games.length === 0) return '';
    if (exportType === 'session') return formatRecap(games.slice(-3), 'Session (3 dernières games)');
    if (exportType === 'block') { const recent = games.slice(-25); return formatRecap(recent, `Bloc (${recent.length} dernières games)`); }
    return formatRecap(games, `Toutes les games (${games.length})`);
  }, [games, exportType]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(exportContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const downloadJSON = () => {
    const blob = new Blob([JSON.stringify(games, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `apex-tracker-backup-${new Date().toISOString().split('T')[0]}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2 flex-wrap">
        {[{ id: 'session', label: 'Session (3 games)' }, { id: 'block', label: 'Bloc (25 games)' }, { id: 'all', label: 'Tout' }].map(opt => (
          <button key={opt.id} onClick={() => setExportType(opt.id)}
            className={`px-4 py-2 text-xs tracking-wider font-semibold transition border ${exportType === opt.id ? 'bg-gradient-to-r from-cyan-400 to-fuchsia-400 text-black border-cyan-400' : 'bg-transparent border-zinc-800 text-zinc-400 hover:border-zinc-700'}`}>
            {opt.label.toUpperCase()}
          </button>
        ))}
        <Button variant="secondary" className="ml-auto flex items-center gap-2" onClick={downloadJSON}><Download size={14} /> BACKUP JSON</Button>
      </div>
      <div className="border border-zinc-800 bg-zinc-900/50">
        <div className="border-b border-zinc-800 p-3 flex items-center justify-between">
          <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase font-semibold">Recap Formaté</div>
          <Button variant="primary" size="sm" onClick={copyToClipboard}>{copied ? '✓ COPIÉ' : 'COPIER'}</Button>
        </div>
        <pre className="p-4 text-xs text-zinc-300 font-mono overflow-x-auto whitespace-pre-wrap max-h-[500px] overflow-y-auto">
          {exportContent || 'Aucune game à exporter'}
        </pre>
      </div>
    </div>
  );
}
